export function updatePortfolio(state, portfoliodata) {
  state.portfolioData = portfoliodata;
}
export function updatePortfolioTransactions(state, portfolioTransactionsData) {
  state.portfolioTransactionsData = portfolioTransactionsData;
}
export function updatePortfolioStock(state, portfolioStocksData) {
  state.portfolioStocksTableData = portfolioStocksData;
}
export function updatePortfolioDemat(state, portfolioDematData) {
  state.portfolioDematTableData = portfolioDematData;
}
export function updatePortfolioFixedBank(state, portfolioFixedBankData) {
  state.portfolioFixedBankTableData = portfolioFixedBankData;
}
export function updatePortfolioSavingBank(state, portfolioSavingBankData) {
  state.portfolioSavingBankTableData = portfolioSavingBankData;
}
export function updatePortfolioLoan(state, portfolioLoanData) {
  state.portfolioLoanTableData = portfolioLoanData;
}
export function updaterealEstate(state, realEstateData) {
  state.realEstateTableData = realEstateData;
}
export function updatecommodity(state, commodityData) {
  state.commodityTableData = commodityData;
}
export function updateBankList(state, banklist) {
  state.bankList = banklist;
}
